import { inject, Injectable } from '@angular/core';
import { FolderEntity, FolderTypes } from '../../../dave-data-module/entities/folder.entity';
import { Observable, ReplaySubject } from 'rxjs';
import { switchMap, map } from 'rxjs/operators';
import { FolderDataService } from '../../../dave-data-module/services/folder-data.service';
import { SharepointObjectEntity } from '../../../dave-data-module/entities/sharepoint-object.entity';
import { SharepointDataService } from './sharepoint/sharepoint-data.service';
import { T } from '@angular/cdk/keycodes';

export interface DMSTreeFolderDataService<T, K> {
    getFolderAndParentsById: (parentId: T) => Observable<K[]>;
    getFolderByParent: (parentId: T) => Observable<K[]>;
    getFolderById: (parentId: T) => Observable<K>;
}

export interface dmsFolder<T> {
    Id: T;
    Name: string;
    Type: FolderTypes | null;
    CanEdit: boolean;
    CreatedAt: Date;
    UpdatedAt: Date;
    AdditionalFields: Map<string,string>;
}
@Injectable()
export class DmsFolderDataWrapperService implements DMSTreeFolderDataService<number | string, dmsFolder<number | string>> {

    private folderData = inject(FolderDataService);
    private sharepointData = inject(SharepointDataService);
    private source$ = new ReplaySubject<'c2go' | 'sharepoint'>(1);
    private mode: 'c2go' | 'sharepoint' = null;
    constructor() { }

    setMode(mode: 'c2go' | 'sharepoint') {
        if (this.mode !== mode) {
            this.mode = mode;
            this.source$.next(mode);
        }
    }
    getMode() {
        return this.mode;
    }

    getFolderAndParentsById(parentId: string | number) {
      return this.source$.pipe(switchMap(src => {
          if (src === 'c2go') {
              return this.folderData.getFolderAndParentsById(parentId as number).pipe(
                  map(folders => folders.map(f => ({...f, AdditionalFields: new Map<string,string>()})))
              );
          } else {
              return this.sharepointData.getFolderAndParentsById(parentId as string).pipe(map(sharepointObjectsToFolders));
          }
      }))
    }
    getFolderByParent(parentId: string | number) {
        return this.source$.pipe(switchMap(src => {
            if (src === 'c2go') {
                return this.folderData.getFolderByParent(parentId as number).pipe(
                    map(folders => folders.map(f => ({...f, AdditionalFields: new Map<string,string>()})))
                );
            } else {
                return this.sharepointData.getFolderByParent(parentId as string).pipe(map(sharepointObjectsToFolders));
            }
        }))
    }
    getFolderById(id: string | number){
        return this.source$.pipe(switchMap(src => {
            if (src === 'c2go') {
                return this.folderData.getFolderById(id as number).pipe(
                    map(f => ({...f, AdditionalFields: new Map<string,string>()}))
                );
            } else {
                return this.sharepointData.getFolderById(id as string).pipe(map(sharepointObjectToFolder));
            }
        }))
    }

}
function sharepointObjectsToFolders (s: SharepointObjectEntity[]): dmsFolder<string>[] {
    return s?.map(sharepointObjectToFolder);
}
function sharepointObjectToFolder (s: SharepointObjectEntity): dmsFolder<string> {
    if (!s) {
        return {
            Id: '0',
            Name: 'kaputt',
            Type: null,
            CanEdit: false,
            CreatedAt: null,
            UpdatedAt: new Date(),
            AdditionalFields: new Map<string,string>()
        }
    }
    return {
        Id: s.Id,
        Name: s.Name,
        Type: null,
        CanEdit: false,
        CreatedAt: null,
        UpdatedAt: s.UpdatedAt,
        AdditionalFields: s.Fields,
    }
}
